// Libraries
import { TypeOf, z } from 'zod';
// Utils
import text from '@translations/en.json';

/**
 * Zod schema for the change password form data.
 */
export const ChangePasswordSchema = z

  .object({
    username: z.string(),
    /**
     * The password input field.
     */
    password: z
      .string({
        required_error: text.password_error_message,
      })
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(.{8,})$/, text.comply_message),
    /**
     * The confirm password input field.
     */
    confirmPassword: z.string({
      required_error: text.confirm_password_error_message,
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: text.not_match_message,
    path: ['confirmPassword'],
  });

/**
 * Represents the type of values accepted by the changePasswordSchema.
 */
export type ChangePasswordValues = TypeOf<typeof ChangePasswordSchema>;
